'use client'
import AllSettingTab from './AllSettingTab'
const ProfileSetting = ({ children, activeTab }) => {
    return (
        <div className="">
            <div className="grid grid-cols-12 gap-4">
                <AllSettingTab activeTab={activeTab}/>
                <div className="col-span-12 lg:col-span-9 box border border-lightGray rounded-2xl p-4 lg:p-7 relative lg:mt-0 w-full bg-white">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default ProfileSetting
